import { Switch } from '@/components/ui/switch';

interface CrosspostToggleProps {
  readonly enabled: boolean;
  readonly onChange: (enabled: boolean) => void;
}

export function CrosspostToggle({ enabled, onChange }: CrosspostToggleProps) {
  return (
    <div
      className="flex items-center justify-between py-2 px-3 rounded-lg"
      style={{
        background: 'hsl(var(--v10-bg-surface))',
        border: '1px solid hsl(var(--v10-border))',
      }}
    >
      <div className="flex items-center gap-2">
        <span className="text-sm text-white/70">Cross-post Instagram</span>
        <span
          className="text-[10px] px-1.5 py-0.5 rounded"
          style={{
            background: enabled ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)',
            color: enabled ? 'rgb(74,222,128)' : 'rgb(248,113,113)',
          }}
        >
          {enabled ? 'Actif' : 'Désactivé'}
        </span>
      </div>
      <Switch
        checked={enabled}
        onCheckedChange={onChange}
        className="scale-75 data-[state=checked]:bg-emerald-500"
      />
    </div>
  );
}
